module.exports = __webpack_public_path__ + "static/media/platform_3.82d0e833.svg";